/** Shared copy + helpers for Naturals Reels capture guide. */

/** At least one process clip is needed; stylists add more as the service requires. */
export const PROCESS_MIN = 1;

/** Live shot checklist — shown during capture; ticks update from validation feedback. */
export const SHOT_CHECKS = [
  { id: 'frame', label: 'Face or hands in frame' },
  { id: 'light', label: 'Good lighting' },
  { id: 'steady', label: 'Hold camera steady' },
];

export const CAPTURE_STAGES = [
  {
    id: 'before',
    step: 1,
    label: 'Before the service',
    shortLabel: 'Before',
    seconds: 6,
    filmWhat: 'Customer before you start — face and shoulders in frame.',
    tapWhat: 'Tap Start recording, then Next step.',
    tipTitle: 'Step 1 — Before the service',
    tipBody:
      'Point the camera at the customer and show how they look before you start. Keep face and shoulders in frame. Hold steady for about 6 seconds.',
    tipDo: 'Tap Start recording when ready, then Next step.',
  },
  {
    id: 'process',
    step: 2,
    label: 'While you work',
    shortLabel: 'During',
    seconds: 12,
    filmWhat: 'Clips of the service in action (cutting, color, styling…).',
    tapWhat: 'Record clips (Pause/Stop available). Done with process when ready.',
    tipTitle: 'Step 2 — While you work',
    tipBody:
      'Film short clips while you work. Each clip is about 12 seconds — Pause or Stop anytime. Add as many as the service needs. The reel uses every clip you save.',
    tipDo: 'Tap Start recording for each clip. Use Pause/Stop while filming. When you have enough, tap Done with process.',
  },
  {
    id: 'result',
    step: 3,
    label: 'The final look',
    shortLabel: 'After',
    seconds: 12,
    filmWhat: 'The finished result — centered and well lit.',
    tapWhat: 'Tap Start recording, then Create reel.',
    tipTitle: 'Step 3 — The final look',
    tipBody:
      'Show the completed look clearly. Keep the customer centered and well lit. About 12 seconds.',
    tipDo: 'Tap Start recording, then Create reel to finish.',
  },
];

export const FULL_JOURNEY_STEPS = [
  {
    step: 1,
    title: 'Record 3 parts',
    detail: 'Before (6s) → During (12s each, as many as needed) → After (12s)',
  },
  {
    step: 2,
    title: 'App builds your reel',
    detail: 'Upload and render run automatically',
  },
  {
    step: 3,
    title: 'Preview & download',
    detail: 'Open from Home when ready',
  },
];

export function actionNowText(stage, localStatus, stageCaptured) {
  if (stage.id === 'before') {
    return stageCaptured
      ? 'Done — tap Next. Clips upload when you create the reel.'
      : stage.filmWhat;
  }
  if (stage.id === 'process') {
    if (localStatus.process < 1) {
      return `Record your first clip: ${stage.filmWhat}`;
    }
    return `${localStatus.process} clip${localStatus.process === 1 ? '' : 's'} ready — tap Next or record more.`;
  }
  return stageCaptured
    ? 'Done — tap Create reel to upload and build your video.'
    : stage.filmWhat;
}

export function stageDone(stage, localStatus) {
  if (stage.id === 'process') return localStatus.process >= PROCESS_MIN;
  return Boolean(localStatus[stage.id]);
}
